'use strict';

module.exports = {
  BOX: 'box'
};


/*****************
 ** WEBPACK FOOTER
 ** ./_drag-around-naive/ItemTypes.js
 ** module id = 70
 ** module chunks = 0
 **/